<template>
  <div
    v-if="this.$store.state.shouldAuth"
    class="fixed w-full inset-0 z-10 overflow-hidden flex justify-center items-center">
    <div
      class="fixed w-full inset-0 z-20 bg-gray-700 opacity-75"
      @click="close()" />
    <login-form-component />
  </div>
</template>

<script>
export default {
  methods: {
    close: function() {
      this.$store.commit('shouldAuth', false);
    },
  },
}
</script>
